exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.perGap1 {\r\n  width: 13px !important;\r\n  font-size: 11px !important;\r\n  line-height: 14px !important;\r\n  height: 70px;\n}\n.perGap {\r\n  height: 90px;\r\n  font-size: 11px !important;\n}\n.tableLay {\r\n  table-layout: fixed;\n}\n.dataAll {\r\n  padding: 0px !important;\n}\nhr {\r\n  margin-top: 0rem !important;\r\n  margin-bottom: 0rem !important;\n}\r\n", ""]);

// exports
